import { Injectable } from '@angular/core';
import { ServiceBase } from './service.base';
import { SegmentoApi } from '../api/segmento.api';
import { ISegmentoDTO } from '../dto/segmento-dto';
import { ISegmento } from '../models/segmento';

@Injectable()
export class SegmentoService extends ServiceBase<ISegmento, ISegmentoDTO> {

    constructor(private api: SegmentoApi) {
        super(api);
    }
}
